/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_UnreachableInputs */

const en_api_unreachable = /** @type {(inputs: Api_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn’t reach Listening. Check your connection and try again.`)
};

const es_api_unreachable = /** @type {(inputs: Api_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo conectar con Listening. Revisa tu conexión e inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Couldn’t reach Listening. Check your connection and try again." |
*
* @param {Api_UnreachableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const api_unreachable = /** @type {((inputs?: Api_UnreachableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_UnreachableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_api_unreachable(inputs)
	return en_api_unreachable(inputs)
});